import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminReturns = lazy(() => import("@/pages/admin/AdminReturns"));

export const Route = createFileRoute("/admin/returer")({
  component: () => <AdminReturns />,
});
